import { BaseItemTypes } from "@/components/dnd/ItemTypes";
import { AnalyticsV2ChartType, AnalyticsV2ElementType, TagType } from "@/models/etc/types";
import { AnalyticsChartIdentity, AnalyticsElementIdentity, AnalyticsElementKind, ParameterLink } from "@/models/interfaces/entity-settings/charts/charts";
import type { AnalyticsWorkloadChartTableAskerBase } from "@/store/auxillary";

/** Тип цели перемещения при DnD: корень сегмента, папка или табличный элемент (выборка/проекция/список). */
export type MoveTargetKind = 'root' | 'folder' | 'table';

export interface AnalyticsRequestData {
    // what i create or change; required fields
    id: number;
    type: BaseItemTypes;
    kind?: AnalyticsElementKind;
    newParentKind?: AnalyticsElementKind;
    destinationType?: AnalyticsV2ElementType;

    // if no - means projection
    sourceType?: AnalyticsV2ElementType;
    newParentId?: number;
    oldParentId?: number;
    newParentCombinedName: string;
    oldParentType?: BaseItemTypes;
    newParentType?: BaseItemTypes;
    // if no - means projection
    newParentSourceType?: AnalyticsV2ElementType;
    newParentDestinationType?: AnalyticsV2ElementType;
    newPosition?: number;
    oldPosition?: number;
    NewName?: string;

    reportIds?: number[];

    parentFolderId?: number;
    setFavorite?: boolean;

    /** Цель перемещения: 'root' = в корень сегмента, 'folder' = в папку, 'table' = к табличному элементу. */
    moveTargetKind?: MoveTargetKind;
    /** Id папки-цели (при moveTargetKind === 'folder'). */
    targetFolderId?: number;
    /** Сегмент папки-цели (при moveTargetKind === 'folder'). */
    targetSegment?: AnalyticsV2ElementType;
    /** Буквально корневой элемент (без родителя) — не путать с «корневая выборка по смыслу», см. комментарии в changeChildParent. */
    isRoot?: boolean;
    /** Тип родителя перетаскиваемого элемента (для проверки «корневая выборка по смыслу»). */
    parentType?: BaseItemTypes;
    /** FolderId перемещаемой папки (при type === FOLDER); для сборки AnalyticsFolderIdentity. */
    movedFolderId?: number;
}

export enum LockedEntityType {
    Default = 0,
    Bill = 1,
    StorageItem = 2
}

export enum EntityLockResultType {
    LockedByYou = 0,
    LockedByOther = 1,
    NotLocked = 2
}

export interface EntityLockResult {
    Type: EntityLockResultType;
    ExpiresAtUtc?: Date;
}

// some edit Asker classes
export interface MultiEditEntityContainer {
    EntityIds: number[];
    TakeAnything: boolean;
    Segment: AnalyticsV2ElementType;
    ElementIdentity?: AnalyticsElementIdentity;
}

export interface MultiEditTagAsker {
    Container: MultiEditEntityContainer;
    TagIds: number[];
}

export interface MultiEditTagStatusEditAsker {
    Container: MultiEditEntityContainer;
    NewStatus: TagType;
}

export interface MultiEditStorageDetailsEditRequest {
    Container: MultiEditEntityContainer;
    Details: string;
    ActionType: MultiEditStorageDetailsEditType;
    UsedDetailsTemplates?: number[];
}

export enum MultiEditStorageDetailsEditType {
    // Дописать инфо к имеющемуся.
    Append = 0,
    // Заменить старое инфо на новое.
    Rewrite = 1
}

export interface MultiEditCommentsRequest {
    Container: MultiEditEntityContainer;
    CommentValue?: string;
    ActionType: MultiEditCommentsType;

    // Указывают на элемент аналитики, в котором живут комментарии. Нужна одна из двух.
    ElementIdentity?: AnalyticsElementIdentity;
    ChartIdentity?: AnalyticsChartIdentity;

    // Только для графика нагрузки: параметры раскрытия сектора или точки кривой,
    // по ним бэкенд восстанавливает набор активностей.
    WorkloadChartTableRequest?: AnalyticsWorkloadChartTableAskerBase;
    ChartType?: AnalyticsV2ChartType;
}

export enum MultiEditCommentsType {
    // Дописать комментарий к имеющемуся.
    Append = 0,
    // Заменить старый комментарий на новый.
    Rewrite = 1
}

export interface PinnedEntitiesSetRequest {
    Container: MultiEditEntityContainer;
}

export interface MultiEditTagAddAsker extends MultiEditTagAsker {        
    NewTags: string[];
}

export interface MultiEditEntityToListAddRequest {
    Container: MultiEditEntityContainer;
    ListId?: number;
    NewListName?: string;
}

export interface MultiEditEntityFromListRemoveRequest {
    Container: MultiEditEntityContainer;
}

export interface MultiEditParameterListAsker {
    Container: MultiEditEntityContainer;
    ParameterTemplateIds: number[];
}

export interface ParameterInstanceValue
{
    StringValue?: string; // Значение строкового типа.
    NumberValue?: number; // значение численных типов.
    BoolValue?: boolean; // значение логического типа.
    SelectedValueId?: number; // выбранное значений из набора.
    NewCreatedValue?: ValueOfSetContainer; // для открытых множеств, если было создано и выбрано новое значение.
    DateValue?: Date; // значение типа "Дата" 
}

export interface ValueOfSetContainer
{
    // Идентификатор значения. Для нового значения не устанавливать.
    Id: number;
    // Название значения типа "Строка".
    NameString: string;
    // Название значения типа "Целый / Дробный".
    NameNumber?: number;
    // Название значения типа "Дата".
    NameDate?: Date;
}

export interface MultiEditParameterValueEditAsker
{
    Container: MultiEditEntityContainer;
    ParameterLink: ParameterLink;
    InstanceValues: ParameterInstanceValue[];
}
